<template>
  <div class="alert" v-if="alertshow1">
    <div class="con">
      <div class="tit"><strong>图灵机器人开放平台隐私权政策</strong></div>
      <div class="btm">
        <div class="fal" @click="unagree">拒绝</div>
        <div class="tru" :class="{active: isRead}" @click="agree">同意<i v-if="!isRead">({{num}}s)</i></div>
      </div>
      <div class="content-wrap">
        <div class="content">
          <h3>版本更新日期：2022年9月29日</h3>
          <h3>版本发布日期：2022年9月29日</h3>
          <p>欢迎您使用图灵机器人开发平台（以下简称“图灵机器人平台”）产品与/或服务，北京光年无限科技有限公司是（注册地址：<strong>北京市石景山区石景山路3号玉泉大厦四层常青藤青年创业工作室193号</strong>，以下简称“<strong>我们</strong>”）系图灵机器人开放平台的运营者。我们一向尊重并会严格保护用户在使用本产品时的合法权益（包括用户信息、隐私信息等）。鉴于此，我们制定本《隐私政策》（以下称为“本政策”），与<strong>您确认关于您在使用平台产品与/或服务期间，我们收集、存储、使用、披露和保护您的个人信息的相关事宜，请您在开始使用我们平台服务之前请务必仔细阅读并理解</strong>。</p>
          <p><strong>如您是未成年人，请在您的父母或其他监护人陪同下仔细阅读并充分理解本政策，并征得您的父母或其他监护人的同意后使用图灵机器人平台产品与/或服务。</strong></p>
          <p><strong>因为只要您使用我们的服务，就表示您同意隐私政策及补充条文中所描述的做法，如果您不同意隐私政策中所描述的做法，您可以选择不使用我们的服务。</strong></p>
          <h3>本政策将帮助您了解以下内容：</h3>
          <p>一、定义与解释</p>
          <p>二、我们如何收集和使用您的个人信息</p>
          <p>三、我们如何使用 Cookie 和同类技术</p>
          <p>四、我们如何委托处理、共享、转让、公开披露您的个人信息</p>
          <p>五、我们如何保护您的个人信息</p>
          <p>六、我们如何存储您的个人信息</p>
          <p>七、我们如何保护未成年人的个人信息</p>
          <p>八、您如何行使管理您个人信息的权利</p>
          <p>九、我们如何更新本政策</p>
          <p>十、如何联系我们</p>
          <p>十一、其他</p>
          <h3>一、定义与解释</h3>
          <p>1、<strong>个人信息</strong>：是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。为免疑义，个人信息包括但不限于敏感个人信息。</p>
          <p>2、<strong>敏感个人信息</strong>：是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，<strong>包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息</strong>。</p>
          <p>3、<strong>个人信息的处理</strong>：包括个人信息的收集、存储、使用、加工、传输、提供、公开、删除等。</p>
          <p>4、<strong>用户</strong>：是指<strong>1）访问图灵机器人网站；2）注册、登录以及使用图灵机器人产品与/或服务的用户；3）通过启用、浏览或上传数据至图灵机器人平台的访问者和开发者；4）使用调用了图灵机器人平台人工智能API/SDK产品与/或服务的最终用户。</strong>在本政策中更多地称为“您”。</p>
          <p>5、<strong>账号</strong>：是指您在图灵机器人平台完成注册用户账号，账号由您自行保管且承担使用账号的相关法律责任。</p>
          <p>6、<strong>匿名化</strong>：是指个人信息经过处理无法识别特定自然人且不能复原的过程。</p>
          <p>7、<strong>去标识化</strong>：是指个人信息经过处理，使其在不借助额外信息的情况下，无法识别特定自然人的过程。</p>
          <p>8、<strong>IP地址</strong>：每台上网的设备都会指定一个编号，称为互联网协议 (IP) 地址。这些编号通常都是根据地理区域指定的。IP 地址通常可用于识别设备连接至互联网时所在的位置。</p>
          <h3>二、我们如何收集和使用您的个人信息</h3>
          <p>1、我们作为您访问、注册或使用图灵机器人平台产品与/或服务时，有关您个人信息的处理者，会遵循合法、正当、必要、诚信的原则，仅将我们主动收集的个人信息和您主动提供的个人信息用于本政策所限定的用途并为您提供个性化服务，以及用于身份验证、安全防范、反诈骗监测以提高产品与/或服务的安全性。为此，我们可能会在您注册、登录、实名认证、使用我们平台产品与/或服务时收集和使用您的个人信息（该类信息包括您的姓名/名称、身份证号码、手机号码、电子邮箱账号等）。</p>
          <p>2、我们可能会对我们提供的服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以用于产品开发、服务优化、安全保障的目的。但这些统计信息不包含您的任何身份识别信息。</p>
          <p>3、根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息而无需征求您的授权同意：</p>
          <p><strong>(1)与我们履行法律法规规定的义务相关的；</strong></p>
          <p><strong>(2)与国家安全、国防安全直接相关的；</strong></p>
          <p><strong>(3)与公共安全、公共卫生、重大公共利益直接相关的；</strong></p>
          <p><strong>(4)与刑事侦查、起诉、审批和判决执行等直接相关的；</strong></p>
          <p><strong>(5)出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</strong></p>
          <p><strong>(6)所涉及的个人信息是个人信息主体或监护人自行向社会公众公开的；</strong></p>
          <p><strong>(7)根据个人信息主体要求签订和履行合同所必需的；</strong></p>
          <p><strong>(8)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</strong></p>
          <p><strong>(9)维护所提供产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障。</strong></p>
          <h3>三、我们如何使用 Cookies 和同类技术</h3>
          <h4><strong>1.我们如何使用Cookies</strong></h4>
          <p>(1)通过使用Cookies，我们向用户提供安全且具个性化的服务体验。我们和第三方合作伙伴会在您的终端设备上存储Cookies、Flash Cookies，或浏览器（或关联应用程序）提供的其他通常包含标识符、站点名称以及一些号码和字符的本地存储（以上合称“Cookies”）。我们和我们的第三方合作伙伴可能通过Cookies收集您的信息，并将信息用于以下用途：安全类Cookies：Cookies可帮助我们保障产品和服务的安全和高效运转。</p>
          <p>(2)<strong>通过平台跳转到第三方平台时或您通过第三方渠道获取我方服务时，该渠道通过Cookies收集和使用您的信息不受本政策约束，而是受到其自身的信息保护声明约束，我们不对第三方的Cookies或同类技术承担责任。</strong></p>
          <h3>四、我们如何委托处理、共享、转让、公开披露您的个人信息</h3>
          <p>1、<strong>委托处理</strong>：我们会委托第三方服务提供商处理我们所收集的您的个人信息，以便其为我们提供基础设施技术、数据分析等产品或技术支持。上述委托处理行为受本政策中所声明目的约束，并且我们会以合同的方式对上述受托的第三方服务提供商进行监督。</p>
          <p>2、<strong>共享</strong>：</p>
          <p><strong>（1）我们可能会与我们的关联公司或合作伙伴共享您的个人信息、用户日志等数据；但是我们只会共享必要的个人信息及日志数据，且受本政策中所声明目的的约束；关联公司也将依据本政策采取同等的安全保障措施来保障您的个人信息安全。</strong></p>
          <p><strong>（2）根据适用的法律法规规定，或按照政府主管部门的强制性要求进行提供。</strong></p>
          <p><strong>3、转让</strong></p>
          <p>我们不会将您的个人信息转让给任何公司、组织和个人，<strong>但在涉及合并、收购、资产转让或破产清算时，如涉及到个人信息转让，我们会向您告知有关情况，并要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新取得您的授权同意。</strong></p>
          <p><strong>4、公开披露</strong></p>
          <p><strong>除</strong>根据相关法律及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得您的授权同意<strong>的例外情况外，本政策另有约定或法律明确规定，我们不会公开披露您的个人信息。例外情况如下：</strong></p>
          <p><strong>(1)与我们履行法律法规规定的义务相关的；</strong></p>
          <p><strong>(2)与国家安全、国防安全直接相关的；</strong></p>
          <p><strong>(3)与公共安全、公共卫生、重大公共利益直接相关的；</strong></p>
          <p><strong>(4)与刑事侦查、起诉、审判和判决执行等直接相关的；</strong></p>
          <p><strong>(5)出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</strong></p>
          <p><strong>(6)个人信息主体或监护人自行向社会公众公开的个人信息；</strong></p>
          <p><strong>(7)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</strong></p>
          <p>2.<strong>请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息。请您谨慎共享或公开，如所涉信息包含他人个人信息，请您在共享或公开前取得他人同意。</strong></p>
          <p>3.<strong>请知悉，根据法律规定，若我们采取技术措施和其他必要措施处理个人信息，使得数据接收方无法重新识别特定个人且不能复原，经上述处理后的数据的共享、转让、公开披露无需另行向您通知并征得您的同意。</strong></p>
          <h3>五、我们如何保护您的个人信息</h3>
          <p>1、我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术（例如SSL）来保护您提供的个人信息。</p>
          <p>2、<strong>请您知悉，虽然我们将尽力确保或担保您发送给我们的任何信息的安全性，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网环境并非百分之百安全，您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题，我们亦不对由此产生或与之相关的任何风险、损失承担责任。</strong></p>
          <h3>六、我们如何存储您的个人信息</h3>
          <p>1、我们将在本政策载明的目的所需及法律法规要求的最短保存期限之内，保存您的个人信息、用户日志等信息。前述期限届满后，我们将对您的个人信息做删除或匿名化处理。</p>
          <p>2、我们在中国境内运营过程中收集和产生的个人信息将保存在中国境内（为本隐私政策之目的，“中国境内”不含中国港澳台地区），以下情形除外：</p>
          <p>(1)<strong>法律有明确规定；</strong></p>
          <p>(2)<strong>获得您的明确授权；</strong></p>
          <p>(3)<strong>您要求获取境外服务等个人主动行为。</strong></p>
          <h3>七、我们如何保护未成年人的个人信息</h3>
          <p>1、我们非常重视对未成年人个人信息的保护。根据相关法律法规的规定，收集、使用未满14周岁的未成年人的个人信息，需由监护人授权同意；收集、使用已满14周岁未满18周岁的未成年人个人信息，可由监护人授权同意或自行授权同意。</p>
          <p>2、<strong>如您为未成年人（尤其是不满14周岁的未成年人），我们要求您请您的父母或其他监护人仔细阅读本隐私政策，并在征得您的监护人授权同意的前提下使用我们的服务或向我们提供信息。</strong></p>
          <p>3、<strong>如您是未成年人的监护人，请您关注您所监护的未成年人是否是在您授权同意之后使用我们的产品或服务。如果您对您所监护的未成年人的个人信息有疑问，请通过本隐私政策载明的方式与我们联系。</strong></p>
          <h3>八、您如何行使管理您个人信息的权利</h3>
          <p>1、在您使用图灵机器人平台产品与/或服务期间，<strong>您可以通过相应页面提示对您的信息进行变更、删除等操作</strong>或本隐私政策载明的方式联系我们，以访问、更正、删除您的个人信息，以及行使注销账号的权利，您的意见会及时得到处理。</p>
          <p>2、<strong>删除您的个人信息</strong></p>
          <p><strong>在以下情形中，您可以通过本隐私政策载明的方式向我们提出删除个人信息的请求：</strong></p>
          <p>(1)<strong>我们违反法律、行政法规或与您的约定收集、使用个人信息；</strong></p>
          <p>(2)<strong>我们违反法律、行政法规或与您的约定与第三方共享或转让您的个人信息，我们将立即停止共享、转让行为，并通知第三方及时删除；</strong></p>
          <p>(3)<strong>我们违反法律、行政法规规定或与您的约定，公开披露您的个人信息，我们将立即停止公开披露的行为，并发布通知要求相关接收方删除相应的信息；</strong></p>
          <p><strong>您不再使用我们的产品或服务，或我们终止服务及运营。</strong></p>
          <h3>九、我们如何更新本政策</h3>
          <p>1、我们的隐私政策可能会适时发生变更。我们会在本页面上发布对本隐私政策所做的任何变更。对于重大变更，我们还会提供更为显著的通知（我们可能会通过在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。<strong>未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。</strong></p>
          <p>2、本隐私政策所指的重大变更包括但不限于：</p>
          <p>（1）我们的服务模式发生重大变化；</p>
          <p>（2）个人信息共享、转让或公开披露的主要对象发生变化；</p>
          <p>（3）您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
          <p>（4）我们的联系方式及投诉渠道发生变化；</p>
          <p>（5）个人信息安全影响评估报告表明存在高风险时。</p>
          <p>3、我们还会将本隐私政策的旧版本存档，供您查阅。</p>
          <h3>十、如何联系我们</h3>
          <p>如果您对本政策或个人信息保护有任何问题，您可以将您的书面疑问、意见或建议通过以下地址寄至客服部门：</p>
          <p>名称：<strong>【图灵机器人】</strong></p>
          <p>地址：<strong>【北京市海淀区农大南路硅谷亮城5号楼6层】</strong></p>
          <p>或您也可以通过以下电子邮箱进行联系：</p>
          <p>联系邮箱：<strong>【turing@uzoo.cn】</strong></p>
          <p>一般情况下，我们将在十五个工作日内回复。<strong>如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向有关监管部门进行投诉或举报，或通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。</strong></p>
          <h3>十一、其他</h3>
          <p>1、与本政策相关的任何纠纷，双方应经友好协商解决；若不能协商解决，您在此同意向北京市石景山区人民法院提起诉讼。</p>
          <p>2、如果有管辖权的任何法院裁定或判决本政策的任何条款无效，则该条款将从本政策中移除，但该条款的无效不影响本政策其余条款的效力。本政策的其余条款将继续执行。</p>
        </div>
      </div>

      <span @click="close">×</span>
    </div>
  </div>
</template>

<script>
    export default{
      props: {
        alertshow1: {
          type: Boolean
        }
      },
      data () {
        return {
          timer: null,
          isRead: false,
          num: 5
        };
      },
      watch: {
        alertshow1: function (val, oldVal) {
          console.log(2);
          this.toRead();
        }
      },
      beforeDeatory () {
        this.num = 5;
        clearInterval(this.timer);
      },
      methods: {
        toRead () {
          clearInterval(this.timer);
          this.num = 5;
          var _this = this;
          this.timer = setInterval(function () {
            _this.num = _this.num - 1;
            if (_this.num <= 0) {
              _this.num = 0;
              clearInterval(_this.timer);
              _this.isRead = true;
            }
          }, 1000);
        },
        close () {
          this.$emit('close1');
          clearInterval(this.timer);
          this.num = 5;
        },
        agree () {
          if (!this.isRead) {
            return false;
          } else {
            this.$parent.onoff = true;
            this.$emit('agree1');
            clearInterval(this.timer);
            this.num = 5;
          }
        },
        unagree () {
          this.$emit('unagree1');
          clearInterval(this.timer);
          this.num = 5;
        }
      }
    };
</script>

<style lang="scss" scoped="" type="text/css">
  .alert{position: fixed;left: 0;right: 0;top: 0;bottom: 0;background: rgba(0,0,0,.5);z-index: 1000;
    .con{width: 544px;height: 80%; background: #fff;margin: 5% auto;-webkit-box-shadow:0 0 5px 0 rgba(0,0,0,.3);-moz-box-shadow:0 0 5px 0 rgba(0,0,0,.3);box-shadow:0 0 5px 0 rgba(0,0,0,.3);padding:0 30px;position: relative;min-height: 500px;  }
    .tit{height: 56px; line-height: 56px;padding-top: 15px;border-bottom:#ddd solid 1px;font-size: 16px;color: #333;position: absolute;top: 0;left: 30px;right: 30px; }
    .btm{height: 100px;border-top:#ddd solid 1px;position: absolute;bottom: 0;left: 30px;right: 30px;
    div{width: 88px; height: 35px; line-height: 35px; text-align: center;float: right;color: #fff;margin-top: 20px;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;cursor: pointer;}
      .fal{margin-left: 10px;background: #bac7d8;}
      .tru{background: #bac7d8;}
      .active {background: #00a3f0;}
    }
    span{position: absolute;right: 40px; top: 20px;font-size: 30px;color: #bac7d8;cursor: pointer;}
    .content-wrap{position: absolute;left: 30px;right: 30px;top: 72px;bottom:101px;overflow: hidden;}
    .content{overflow-y: scroll;width: 564px;height: 100%;}
    h3 {line-height: 20px; font-size: 14px; color: #333; padding-top: 20px; font-weight: bold;}
    h4 {line-height: 20px; font-size: 12px; color: #333; padding-top: 20px; font-weight: bold;}
    p {line-height: 20px;font-size: 12px;color: #666;padding-top: 20px;text-indent:24px;}
    ul {padding-top:20px;list-style: inside;li {line-height: 18px; font-size: 12px;padding: 6px 0; color: #666;}}
  }
</style>



// WEBPACK FOOTER //
// userAgreement.vue?84e092f6